"use client";

import dynamic from "next/dynamic";

import type { BlockCustomersStoriesProps } from "./BlockCustomersStories";

const BlockCustomersStories = dynamic(() => import("./BlockCustomersStories").then(mod => mod.BlockCustomersStories));

export const BlockCustomersStoriesWrapper = (props: BlockCustomersStoriesProps) => {
  return <BlockCustomersStories {...props} />;
};
